import API from '../Api';

export const deletePropertyApi = ({ nid }) => {
  return API.delete(process.env.REACT_APP_DELETE_PROPERTY, {
    data: { nid },
  });
};
